export default "__VITE_ASSET__6ddb5606__"